export default class MobileSubmenu {
    constructor(elm) {
        var submenu = elm.querySelector('[data-js="mobile-submenu"]');
        var submenuExpander = elm.querySelector('[data-js="mobile-submenu-expand"]');
        var submenuCollapser = elm.querySelector('[data-js="mobile-submenu-collapse"]');

        submenuExpander.addEventListener('click', () => {
            submenu.classList.add('dropdown-menu--active');
        });

        submenuCollapser.addEventListener('click', () => {
            submenu.classList.remove('dropdown-menu--active');
        });

    }
}
